import React from "react";
import {connect} from "react-redux";
import {
  Show,
  TextField,
  SimpleShowLayout,
  DateField,
  translate,
  showNotification as showNotificationAction,
} from "admin-on-rest";
import TextFieldStoreMessage from '../../../components/CRM/TextFieldStoreMessage';
import ActionBar from "../../../components/CRM/ActionBar/";
import {viewStyle} from "./style";
import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
import restClient from "../../../restClient";
import {UPDATE} from "admin-on-rest";
import Dialog from "material-ui/Dialog";
import {BMTheme} from "../../../BMTheme";

class StoreMessageShowItem extends React.Component {
  state = {
    isLoading: false,
    isSent: false,
    showConfirm: false
  };

  handleSendButton = () => {
    this.setState({showConfirm: true});
  };

  handleConfirmSend = () => {
    const {showNotification, id} = this.props;
    this.setState({isLoading: true, showConfirm: false});

    restClient(UPDATE, "store_messages", {
      id: id,
      data: {
        state: "SCHEDULED"
      },
      previousData: {state: "DRAFT"}
    })
      .then(() => {
        this.setState({isLoading: false, isSent: true});
        showNotification("aor.notification.sent");
        const {history} = this.props;
        history.replace(`/store_messages`);
      })

      .catch(error => {
        showNotification(error.message, "warning");
      });
  };

  handleCloseDialog = () => {
    this.setState({showConfirm: false});
  };

  render() {
    const props = {...this.props};
    const {record} =  this.props;
    const {isLoading, isSent} = this.state;

    const confirmButton = props.translate(
      "resources.storeMessages.fields.dialogBox.confirmButton"
    );
    const cancelButton = props.translate(
      "resources.storeMessages.fields.dialogBox.cancelButton"
    );

    // Sending is disabled if trigerred in this lifecycle, and also for all statuses except DRAFT
    const sendingDisabled = (isSent || (record && record.state !== "DRAFT"));

    const dialogAction = [
      <div style={viewStyle.dialogAction}>
        <RaisedButton
          label={confirmButton}
          onClick={this.handleConfirmSend}
          primary
          style={viewStyle.raisedButton}
          labelColor={BMTheme.palette.alternateTextColor}
        />

        <RaisedButton
          label={cancelButton}
          secondary
          onClick={this.handleCloseDialog}
          style={viewStyle.raisedButton}
          labelColor={BMTheme.palette.alternateTextColor}
        />
      </div>
    ];

    return (
      <Show
        title="resources.storeMessages.titleEdit"
        {...props}
        actions={
          <ActionBar
            {...props}
            actionBarForShowView={true}
            editButton={this.props.record}
          />
        }
      >
        <SimpleShowLayout {...props}>
          <TextFieldStoreMessage
            label="resources.storeMessages.fields.storeName"
            source="kiosk_name"
          />

          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.smsFrom"
            source="sms_from"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.smsText"
            source="sms_text"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.emailFrom"
            source="email_from"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.emailSubject"
            source="email_subject"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.emailPlainText"
            source="email_plaintext"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.emailHtmlText"
            source="email_html"
          />
          <DateField
            style={viewStyle.textFieldStyle}
            label="resources.storeMessages.fields.sentAt"
            source="sent_at"
          />

          {this.state.showConfirm && (
            <div>
              <Dialog
                title={props.translate(
                  "resources.storeMessages.fields.dialogBox.confirmMessage"
                )}
                actions={dialogAction}
                modal={false}
                open={this.state.showConfirm}
                onRequestClose={this.handleCloseDialog}
              >
                {props.translate(
                  "resources.storeMessages.fields.dialogBox.warningMessage"
                )}
              </Dialog>
            </div>
          )}

          <div>
            <RaisedButton
              label={
                isLoading === true ? (
                  <CircularProgress
                    size={25}
                    thickness={2}
                    color={BMTheme.palette.alternateTextColor}
                    style={viewStyle.raisedButtonProgress}
                  />
                ) : (
                  <span style={viewStyle.raisedButtonLabel}>
                    {this.props.translate("aor.action.send")}
                  </span>
                )
              }
              onClick={this.handleSendButton}
              primary
              style={viewStyle.raisedButton}
              labelColor={BMTheme.palette.alternateTextColor}
              disabled={sendingDisabled}
            />
          </div>
        </SimpleShowLayout>
      </Show>
    );
  }
}

const mapStateToProps = (state, props) => ({
  id: decodeURIComponent(props.match.params.id),
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null
});

const mapDispatchToProps = dispatch => ({
  showNotification: showNotificationAction
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(StoreMessageShowItem));



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/StoreMessageShowItem.js